/* global _, Highcharts */

// @formatter:off
(function () {
  'use strict';

  var id = "activity";
  angular.module('wsLrs.cards').factory(id + ".SummaryCharts", [id + ".ActivityCardResource", "numberFilter", 'wsColors', 'ChartUtils', function (ActivityResource, numberFilter, wsColors, ChartUtils) {
    var getAggregateCount = function getAggregateCount(data, measure, dateFormat) {
      // collect counts over specified dateFormat
      var results = _(data).reduce(function (m, v, i) {
        var t = moment.utc(i),
          k = t.format(dateFormat);
        if (!m.hasOwnProperty(k)) {
          m[k] = {
            "participated": 0,
            "completed": 0,
            "succeeded": 0,
            "scoreCount": 0,
            "scoreTotal": 0,
            "firstScoreTotal": 0,
            "lastScoreTotal": 0,
            "bestScoreTotal": 0,
            "durationCentisecondsTotal": 0,
            "date": k,
            "rawDate": moment.utc(k, dateFormat).valueOf()
          };
        }
        m[k].participated += v.participated;
        m[k].completed += v.completed;
        m[k].succeeded += v.succeeded;
        m[k].scoreCount += v.scoreCount;
        m[k].scoreTotal += v.averageScore * v.scoreCount;
        m[k].firstScoreTotal += v.averageFirstScore * v.scoreCount;
        m[k].lastScoreTotal += v.averageLastScore * v.scoreCount;
        m[k].bestScoreTotal += v.averageBestScore * v.scoreCount;
        m[k].durationCentisecondsTotal += v.averageDurationCentiseconds * v.participated;
        return m;
      }, {}, this);

      // compute averages & formatted values
      // todo: allow formattedDuration units to be auto determined based on value
      _(results).each(function (m) {
        m.averageScore = m.scoreCount === 0 ? 0 : m.scoreTotal / m.scoreCount;
        m.averageFirstScore = m.scoreCount === 0 ? 0 : m.firstScoreTotal / m.scoreCount;
        m.averageLastScore = m.scoreCount === 0 ? 0 : m.lastScoreTotal / m.scoreCount;
        m.averageBestScore = m.scoreCount === 0 ? 0 : m.bestScoreTotal / m.scoreCount;
        m.avgDurationCentiseconds = m.participated === 0 ? 0 : m.durationCentisecondsTotal / m.participated;
        m.formattedDuration = Math.round(moment.duration(m.avgDurationCentiseconds * 10).asMinutes());
      });
      return results;
    };
    return {
      getCompletionsSubtitle: function getCompletionsSubtitle(activityTitle, data) {
        var moments = _(data.results).keys().map(function (m) {
          return moment.utc(m); // create UTC moments
        });
        if (moments.length === 0) {
          return "";
        }
        var minDate = moment.min(moments),
          maxDate = moment.max(moments),
          dateFormat = "MMM D",
          dateFormatWithYear = dateFormat + ", YYYY",
          beginningDateFormat = minDate.year() === maxDate.year() ? dateFormat : dateFormatWithYear;
        var registrationCount = _(data.results).reduce(function (memo, d) {
          return memo + d.completed;
        }, 0);
        var registration = " registrations";
        if (registrationCount === 1) {
          registration = " registration";
        }
        return numberFilter(registrationCount, 0) + registration + " of " + activityTitle + " between " + minDate.format(beginningDateFormat) + " and " + maxDate.format(dateFormatWithYear) + ".";
      },
      getTimeChart: function getTimeChart(data, duration, displayName, displayField, hideSuccesses, config) {
        displayName = displayName || "Completions";
        displayField = displayField || "completed";
        hideSuccesses = hideSuccesses || false;

        // todo: this could be done just once for each duration, saving the results in a cache object
        var yearFormat = "YYYY";
        var dateFormat = yearFormat;
        var tooltipDateFormat = "Year of %Y";
        var xAxisDateFormat = "%Y";
        var dayTickInterval = 3600 * 24 * 1000; // = millliseconds in one day
        var pointWidth = dayTickInterval * 365;
        duration = duration || "month";
        if (duration.toLowerCase() === "month") {
          dateFormat = "YYYY MMM";
          tooltipDateFormat = "Month of %b %Y";
          xAxisDateFormat = "%b %Y";
          pointWidth = dayTickInterval * 30;
        } else if (duration.toLowerCase() === "week") {
          dateFormat = "YYYY WW";
          tooltipDateFormat = "Week of %b %e, %Y";
          xAxisDateFormat = "%b %e, %Y";
          pointWidth = dayTickInterval * 7;
        } else if (duration.toLowerCase() === "day") {
          dateFormat = "YYYY MMM DD";
          tooltipDateFormat = "%b %e, %Y";
          xAxisDateFormat = "%b %e, %Y";
          pointWidth = dayTickInterval;
        }
        var results = getAggregateCount(data.results, displayField, dateFormat);
        var hasSuccesses = _(results).any(function (m) {
          return m.succeeded > 0;
        });
        var sortedValues = _(results).sortBy('rawDate');
        var series = _(sortedValues).map(function (v) {
          return [v.rawDate, Math.round(v[displayField])];
        });
        var maxValue;
        if (displayField.match(/^average.*Score$/)) {
          maxValue = 100;
        } else if (displayField === 'completed') {
          maxValue = _.max(_(results).map(function (v) {
            return Math.max(v.completed, v.succeeded);
          }));
        } else {
          maxValue = _.max(_(results).pluck(displayField));
        }
        maxValue = Math.max(maxValue, 1); // ensure y-range > 0

        var chart = {
          chart: {
            type: 'column',
            plotBorderWidth: 1,
            // Not used, but forces charts to re-render so that it doesn't
            // appear broken if the data is the same for every tab
            selectedTab: displayField
          },
          title: {
            text: ''
          },
          xAxis: {
            type: 'datetime',
            labels: {
              formatter: function formatter() {
                return Highcharts.dateFormat(xAxisDateFormat, this.value, true);
              }
            },
            startOfWeek: 1,
            tickInterval: pointWidth
          },
          yAxis: {
            allowDecimals: false,
            min: 0,
            max: maxValue,
            title: {
              text: ''
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            column: {
              minPointLength: 3,
              pointRange: pointWidth
            }
          },
          tooltip: {
            formatter: function formatter() {
              var tool = '<div class="watershed-tooltip" ><table><thead><tr><th>' + Highcharts.dateFormat(tooltipDateFormat, new Date(this.x)) + '</th></tr></thead>';
              _.each(this.points, function (p) {
                var display = p.series.name.toLowerCase();
                if (p.y === 1) {
                  display = display.replace(display === "successes" ? /es$/ : /s$/, '');
                }
                tool += '<tr style="color:' + p.series.color + '"><td>' + numberFilter(p.y, 0) + ' ' + display + '</td></tr>';
              });
              tool += '</table></div>';
              return tool;
            },
            shared: true
          },
          series: [{
            name: displayName,
            color: ChartUtils.getSeriesColor(config, 0, wsColors.wsBlue),
            data: series
          }]
        };
        if (displayField === "completed" && hasSuccesses && !hideSuccesses) {
          var successSeries = _(sortedValues).map(function (v) {
            return [v.rawDate, v.succeeded];
          });
          chart.series.push({
            name: "Successes",
            color: ChartUtils.getSeriesColor(config, 1, wsColors.wsGreen),
            data: successSeries
          });
          chart.legend = {
            enabled: true
          };
        }
        return chart;
      },
      getScoresChart: function getScoresChart(data, scoreType, config) {
        scoreType = scoreType || 'all';
        var results = data.results[scoreType + 'Scores'];
        function convertPercentages(d) {
          var result = Math.round(parseFloat(d.percent) * 100);
          if (isNaN(result)) {
            result = undefined;
          }
          return result;
        }
        return {
          chart: {
            type: 'column',
            plotBorderWidth: 1
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: _(results).pluck("range")
          },
          yAxis: {
            allowDecimals: false,
            min: 0,
            max: _.max(_(results).map(convertPercentages)),
            labels: {
              formatter: function formatter() {
                return this.isFirst ? this.value + '%' : this.value;
              }
            },
            title: {
              text: ''
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            column: {
              minPointLength: 0
            }
          },
          tooltip: {
            formatter: function formatter() {
              var tool = '<div class="watershed-tooltip" ><table><thead><tr><th>' + this.y + '% of registrations</th></tr></thead>';
              tool += '<tr style="color' + this.series.color + '"><td>scored ' + this.point.category + '</td></tr>';
              tool += '</table></div>';
              return tool;
            }
          },
          series: [{
            name: 'Percent',
            color: ChartUtils.getSeriesColor(config, 0, wsColors.wsBlue),
            data: _(results).map(convertPercentages)
          }]
        };
      },
      getActivityCount: function getActivityCount(cardId, cardToPreview) {
        var params = cardToPreview ? {
          params: {
            config: {
              filter: cardToPreview.configuration.filter
            }
          }
        } : {
          params: {
            cardId: cardId
          }
        };
        return new ActivityResource(cardToPreview).count.get("", params).then(function (response) {
          return response.count || 0;
        });
      }
    };
  }]);
  // formatter:on
})();
